import { Schemas } from '~/api/gen'
import { setAffiliateObjectCookie } from '~/features/shared/affiliate/lib/setAffiliateObjectCookie'
import { ItemFooter } from '~/features/shared/components/Card/ItemFooter'
import { CoordinateCard } from '~/features/shared/coordinate/components/CoordinateCard/CoordinateCard'
import { SkeletonItem } from '~/features/shared/coordinate/components/CoordinateCard/SkeletonItem'
import {
  convertToCoordinatePropsFromCoordinateCollection,
  convertToItemProps,
} from '~/features/shared/coordinate/lib/convertToCardProps'
import { ScreenIds } from '~/types/screenIds'

type Props = {
  coordinates: Schemas.coordinate_collection_with_display_title_and_coordinate_items[]
  coordinateItems?: Schemas.coordinate_item_with_coordinate_id[]
  isLoadingCoordinateItems?: boolean
}

export const Coordinates: React.FC<Props> = ({
  coordinates,
  coordinateItems,
  isLoadingCoordinateItems,
}) => {
  return (
    <div className="grid grid-cols-3 gap-[1px] xl:grid-cols-4 xl:gap-[18px]">
      {coordinates.map((coordinate, i) => {
        const coordinateItem = coordinateItems?.find(
          (item) => item.coordinate_id === coordinate.id
        )?.coordinate_item
        return (
          <div key={coordinate.id}>
            <CoordinateCard
              coordinate={convertToCoordinatePropsFromCoordinateCollection(
                coordinate
              )}
              imagePriority={i < 6}
              // PCのとき1枚目、SPのとき2枚目がLCP
              imageFetchPriority={i === 0 || i === 1}
            >
              <div className="hidden xl:block">
                {isLoadingCoordinateItems || coordinateItem == null ? (
                  <SkeletonItem />
                ) : (
                  <ItemFooter
                    {...convertToItemProps(coordinateItem)}
                    onLinkClick={() => {
                      setAffiliateObjectCookie({
                        screenId: ScreenIds.User,
                        objectId: coordinate.id,
                      })
                    }}
                  />
                )}
              </div>
            </CoordinateCard>
          </div>
        )
      })}
    </div>
  )
}
